<template>
  <v-footer
    absolute
    class="font-weight-light"
    color="#222"
    style="z-index: 100000"
  >
    <v-row>
      <v-col class="text-left" style="color:#999999" cols="12" md="4">
        Copyright © 2020 Haus des Stiftens gGmbH
      </v-col>
      <v-col class="text-right" style="color:#999999" cols="12" md="8">
        <a
          target="_blank"
          href="https://www.hausdesstiftens.org/rechtliches/gender-hinweis/"
        >
          Gender-Hinweis</a
        >
        ·
        <a
          target="_blank"
          href="https://www.hausdesstiftens.org/rechtliches/leichte-sprache/"
          >Leichte Sprache
        </a>
        ·
        <a
          target="_blank"
          href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
        >
          Nutzungsbedingungen
        </a>
        ·
        <a
          target="_blank"
          href="https://www.hausdesstiftens.org/rechtliches/haftungsausschluss/"
        >
          Haftungsausschluss
        </a>
        ·
        <a
          target="_blank"
          href="https://www.hausdesstiftens.org/rechtliches/datenschutz/"
        >
          Datenschutz
        </a>
        ·
        <a
          target="_blank"
          href="https://www.hausdesstiftens.org/rechtliches/impressum/"
        >
          Impressum</a
        >
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
a {
  color: #999999 !important;
  text-decoration: none !important;
}
a:hover {
  color: #7d9b38 !important;
  text-decoration: none !important;
}
</style>
